import { API_BASE_URL, HEADERS_WITH_TOKEN } from "services/api/BaseUrl"

export const getMenus = async () => {
  const usr = JSON.parse(localStorage.getItem('mqadusr'))
  const bo = JSON.parse(localStorage.getItem('mqBO'))

  const res = await fetch(
    `${API_BASE_URL}/menus?cmp=${usr.company._id}&bo=${bo._id}`,
    {
      method: 'GET',
      headers: HEADERS_WITH_TOKEN(localStorage.getItem('mqadtk'))
    }
  )
  return await res.json()
}